var maps = {};

function createmap(m, opts) {
    var myOptions = {
        zoom: opts.zoom ? opts.zoom : 12,
        maxZoom: opts.maxZoom ? opts.maxZoom : 18,
        center: new google.maps.LatLng(opts.lt, opts.ln),
        mapTypeId: google.maps.MapTypeId.ROADMAP
    };
    var element = opts.element ? opts.element : document.getElementById(m);
    maps[m] = new google.maps.Map(element, myOptions);
    maps[m + "_bnds"] = new google.maps.LatLngBounds();

    if (opts.mrkr) {
        createmarker(m, opts.mrkr.lt, opts.mrkr.ln, opts.mrkr.title, opts.mrkr.html ? opts.mrkr.html : "", opts.mrkr.markersettings);
    }
}
var openwindow;
function createmarker(m, lt, ln, ttl, html, markersettings, cicon) {
    var latlng = new google.maps.LatLng(lt, ln);
    var allMarkers = maps[m + "_mkrs"];

    if (allMarkers && allMarkers.length !== 0) {
        for (i = 0; i < allMarkers.length; i++) {
            var existingMarker = allMarkers[i];
            var pos = existingMarker.getPosition();

            //if a marker already exists in the same position as this marker
            if (latlng.equals(pos)) {
                //update the position of the coincident marker by applying a small multipler to its coordinates
                var newLat = latlng.lat() + (Math.random() - .5) / 1500;// * (Math.random() * (max - min) + min);
                var newLng = latlng.lng() + (Math.random() - .5) / 1500;// * (Math.random() * (max - min) + min);
                pos = new google.maps.LatLng(newLat, newLng);
            }
        }
    }

    var marker;
    if (markersettings) {
        marker = new MarkerWithLabel({
            position: latlng,
            map: maps[m],
            labelContent: ttl,
            labelAnchor: new google.maps.Point(33, 24),
            labelClass: "maplabels", // the CSS class for the label
            labelInBackground: false,
            icon: markersettings.favourite? "/_resources/files/icons/marker-favourite.png" : "/_resources/files/icons/marker.png"
        });
    } else if (markersettings === false) {
        marker = new google.maps.Marker({
            map: maps[m],
            position: latlng
        });
    } else {
        marker = new google.maps.Marker({
            map: maps[m],
            position: latlng,
            icon: cicon ? cicon : "/_resources/files/icons/marker-orange.png"
        });
    }

    if (html !== "") {
        marker.infoWindow = new google.maps.InfoWindow({ maxWidth: 300 });
        google.maps.event.addListener(marker, 'click', function () {
            if (openwindow) {
                openwindow.close();
                wcbs.dom.get(maps[m].getDiv()).cssremove("mapscrlron");
            }
            openwindow = marker.infoWindow;
            marker.infoWindow.setContent(html);
            marker.infoWindow.open(maps[m], this);
        });
        google.maps.event.addListener(maps[m], "click", function (event) {
            marker.infoWindow.close();
            if (maps[m + "_coverage"] !== undefined && maps[m + "_coverage"] !== null) {
                maps[m + "_coverage"].setMap(null);
                maps[m + "_coverage"] = null;
            }
        });
        google.maps.event.addListener(marker.infoWindow, 'closeclick', function () {
            if (maps[m + "_coverage"] !== undefined && maps[m + "_coverage"] !== null) {
                maps[m + "_coverage"].setMap(null);
                maps[m + "_coverage"] = null;
            }
            wcbs.dom.get(maps[m].getDiv()).cssremove("mapscrlron");
        });
        google.maps.event.addListener(marker.infoWindow, 'domready', function () {
            // Cusomtise the infowindow
            // Reference to the DIV which receives the contents of the infowindow
            var iwOuter = document.querySelectorAll(".gm-style-iw")[0];
            // The DIV we want to change is above the .gm-style-iw DIV.
            var iwBackground = wcbs.dom.get(iwOuter.previousSibling);
            // Remove the background shadow DIV
            iwBackground.child("div", 1).attr("style", "display: none;");
            // Remove the white background DIV
            iwBackground.child("div", -1).attr("style", "display: none;");
            // Changes the z-index of the arrow.
            var dvs = iwBackground.child("div", 2).selectall("div");
            for (var i = 0; i < dvs.length; i++) {
                dvs[i].attr("style", dvs[i].getattr("style") + "z-index: 1;");
            }
            iwOuter.parentNode.style.width = "250px";
            // Move the close button
            var iwCloseBtn = iwOuter.nextSibling;
            iwCloseBtn.style.right = "0px";
            iwCloseBtn.style.top = "17px";
        });
    }

    setbounds(m, latlng);
    return marker;
}

function removemarker(m, mkr) {
    mkr.setMap(null);
    setbounds(m);
}

function setbounds(m, p) {

    if (p !== undefined) {
        maps[m + "_bnds"].extend(p);
    }
    maps[m].fitBounds(maps[m + "_bnds"]);
    maps[m].setCenter(maps[m + "_bnds"].getCenter());
}

//Student areas map
function loadmap(mdiv, opts, ldiv) {
    var mapOptions = {
        zoom: opts.zoom ? opts.zoom : 15,
        center: new google.maps.LatLng(opts.clat, opts.clng),
        mapTypeId: google.maps.MapTypeId.ROADMAP,
    }

    var map = new google.maps.Map(document.getElementById(mdiv), mapOptions);

    if (opts.marker) {
        var marker = createMarkers(new google.maps.LatLng(opts.marker.lat, opts.marker.lng), map, opts.marker.title)
    }

    // Add any overlays
    if (opts.overlays) {

        for (var i = 0; i < opts.overlays.length; i++) {
            var color = "";
            //Set the area colour
            if (opts.overlays[i].fn.name === "heath") {
                colour = '#00b2a9';
            } else if (opts.overlays[i].fn.name === "cathays") {
                colour = '#DEFFAB';
            } else if (opts.overlays[i].fn.name === "roath") {
                var colour = '#FFC0CB';
            } else if (opts.overlays[i].fn.name === "adamsdown") {
                colour = '#00b2a9';
            }

            var ovly = new google.maps.Polygon({
                paths: opts.overlays[i].fn(),
                strokeColor: colour,
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: colour,
                fillOpacity: 0.35
            });

            ovly.setMap(map);
        }
    }

    // Add any marker groups
    if (opts.groups) {

        var markerGroups = {};
        var infoWindow = new google.maps.InfoWindow({ maxWidth: 300 });

        // Add legend
        var leg = null;
        if (ldiv) { leg = wcbs.dom.get(ldiv).append("UL"); }

        this.togglemarkers = function (o) {
            // get the src object
            o["target"] ? o = o["target"] : o = o["srcElement"];
            while (o.tagName !== "LI") {
                o = o.parentNode;
            }

            // Toggle markers
            for (var i = 0; i < markerGroups[o.getAttribute("data-type")].length; i++) {
                var marker = markerGroups[o.getAttribute("data-type")][i];
                marker.setVisible(!o.getAttribute("data-status") === "on");
            }

            if (o.getAttribute("data-status") === "on") {
                o.setAttribute("data-status", "off");
                o.getElementsByTagName("IMG")[0].setAttribute(
                    "src",
                    o.getElementsByTagName("IMG")[0].getAttribute("src").replace(o.getAttribute("data-type"), "off")
                );
            } else {
                o.setAttribute("data-status", "on");
                o.getElementsByTagName("IMG")[0].setAttribute(
                    "src",
                    o.getElementsByTagName("IMG")[0].getAttribute("src").replace("off", o.getAttribute("data-type"))
                );
            }
        }

        for (var i = 0; i < opts.groups.length; i++) {
            markerGroups[opts.groups[i].name] = [];

            var m = opts.groups[i].fn.markers;

            for (var j = 0; j < m.length; j++) {
                var ticon = getIcon(m[j].icon, m[j].area);

                var mc = {
                    position: m[j].point,
                    map: map,
                    html: m[j].html
                }
                if (opts.groups[i].fn.icon) { mc.icon = ticon }
                if (opts.groups[i].fn.shadow) { mc.shadow = opts.groups[i].fn.shadow; }

                var marker = new google.maps.Marker(mc);
                markerGroups[opts.groups[i].name].push(marker);

                if (m[j].area !== "") {

                    switch (area) {
                        case "heath":
                        case "adamsdown":
                        case "roath":
                        case "cathays":
                            google.maps.event.addListener(marker, 'click', function () { popup(area) });
                            break;
                        default:
                            google.maps.event.addListener(marker, 'click', function () { popup("") });
                            break;
                    }
                }
            }

            if (leg !== null) {
                // Add legend item
                var lli = leg.append("LI").attr("data-type", opts.groups[i].name).attr("data-status", "on").event("click", this.togglemarkers)
                lli.append("IMG").attr("src", opts.groups[i].fn.legicon).attr("alt", opts.groups[i].name);
                lli.text(opts.groups[i].name);
            }
        }
    }
}

function getIcon(icon, area) {
    if (icon !== "") { return icon; }

    //Testimonial icon by area
    switch (area) {
        case "heath":
        case "adamsdown":
        case "roath":
        case "cathays": return "/_resources/files/icons/" + area + ".png";
    }
    return "/_resources/files/icons/pin-orange.png";
}

function createMarkers(point, map, title) {

    var marker = new google.maps.Marker({
        position: point,
        map: map,
        title: title
    });

    return marker;
}

// Marker pop up
function popup(l) {

    var container = document.getElementById("popups").children;
    var legend = document.getElementById("legend");

    for (var i = 0; i < container.length; i++) {

        if (container[i].id === l) {

            if (container[i].className === "hide") {
                container[i].className = "mi";
                //If on the smaller map hide the legend on pop open
                if (window.innerWidth < 920) { legend.className = "noleg"; }
            } else {
                container[i].className = "hide";
                legend.className = "leg";
            }
        } else {
            container[i].className = "hide";
        }
    }
}

google.maps.Polygon.prototype.getBounds = function () {
    var bounds = new google.maps.LatLngBounds();
    var paths = this.getPaths();
    var path;
    for (var i = 0; i < paths.getLength() ; i++) {
        path = paths.getAt(i);
        for (var ii = 0; ii < path.getLength() ; ii++) {
            bounds.extend(path.getAt(ii));
        }
    }
    return bounds;
}